export enum CampaignHeroSectionElementTypeEnum {
  HEADER = 'header',
  BUTTON = 'button',
  IMAGE = 'image',
  TEXT = 'text',
  VIDEO = 'video',
  FORM = 'form',
}
